export default {"src":"/_next/static/media/home-menu-home-new.1b6be38b.svg","height":14,"width":14};